import * as React from 'react';
import { useTranslation } from "react-i18next";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { CustomInput, CustomCheckbox } from "../ButtonComponentsPanel/CustomInputsComponents";

export default function FarmMovementDetailsComponents(props) {
    const { t } = useTranslation();
    const [loading, setLoading] = React.useState(true);

    const [movement, setMovement] = React.useState({
        "movementId": 0,
        "integratorId": 0,
        "farmId": 0,
        "groupId": 0,
        "movementTypeId": 0,
        "movementDate": "",
        "description": "",
        "heads": 0,
        "status": 0,
        "isClosed": true,
        "origin": "",
        "averageWeight": 0,
        "exported": true,
        "reference": "",
        "planned": true,
        "integratorName": "",
        "farmName": "",
        "movementTypeDescription": "",
        "statusDescription": ""
    });

    React.useEffect(() => {
        if (props.movement.movementId !== "") {
            setMovement({
                "movementId": props.movement.movementId,
                "integratorId": props.movement.integratorId,
                "farmId": props.movement.farmId,
                "groupId": props.movement.groupId,
                "movementTypeId": props.movement.movementTypeId,
                "movementDate": props.movement.movementDate,
                "description": props.movement.description,
                "heads": props.movement.heads,
                "status": props.movement.status,
                "isClosed": props.movement.isClosed,
                "origin": props.movement.origin,
                "averageWeight": props.movement.averageWeight,
                "exported": props.movement.exported,
                "reference": props.movement.reference,
                "planned": props.movement.planned,
                "integratorName": props.movement.integratorName,
                "farmName": props.movement.farmName,
                "movementTypeDescription": props.movement.movementTypeDescription,
                "statusDescription": props.movement.statusDescription
            });

            setLoading(false);
        }
        
    }, [props.movement]);

    return (
        <div>
            <Form
                initialValues={movement}
                key={JSON.stringify(movement)}
                render={(formRenderProps) => (
                    <FormElement>
                        <fieldset>
                            <div className="container-fluid">
                                <div className="card">
                                    <div className="card-header">
                                        <b className="card-title">
                                            {t("Global_Label_Text_General")}
                                        </b>
                                    </div>

                                    <div className="container p-3 p-md-4">
                                        <div className="row g-3 mb-3">
                                            <div className="col-12 col-md-4">
                                                <Field
                                                    label={t("FarmMovements_Description")}
                                                    name="description"
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={true}
                                                />
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <Field
                                                    label={t("FarmMovements_MovementType")}
                                                    name="movementTypeDescription"
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={true}
                                                />
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <Field
                                                    label={t("FarmMovements_MovementDate")}
                                                    name="movementDate"
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>

                                        <div className="row g-3 mb-3">
                                            <div className="col-12 col-md-4">
                                                <Field
                                                    label={t("FarmMovements_Heads")}
                                                    name="heads"
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={true}
                                                />
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <Field
                                                    label={t("FarmMovements_AverageWeight")}
                                                    name="averageWeight"
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={true}
                                                />
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <Field
                                                    label={t("FarmMovements_Status")}
                                                    name="statusDescription"
                                                    component={CustomInput}
                                                    loading={loading}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>

                                        <div className="row g-3">
                                            <div className="col-12 col-md-4">
                                                <Field
                                                    label={t("FarmMovements_Status_Closed")}
                                                    name="isClosed"
                                                    component={CustomCheckbox}
                                                    loading={loading}
                                                    disabled={true}
                                                />
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <Field
                                                    label={t("FarmMovements_Planned")}
                                                    name="planned"
                                                    component={CustomCheckbox}
                                                    loading={loading}
                                                    disabled={true}
                                                />
                                            </div>

                                            <div className="col-12 col-md-4">
                                                <Field
                                                    label={t("FarmMovements_Exported")}
                                                    name="exported"
                                                    component={CustomCheckbox}
                                                    loading={loading}
                                                    disabled={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>

                        <div className="float-end k-form-buttons">
                            <button
                                type="submit"
                                disabled={!formRenderProps.allowSubmit}
                                className="k-button"
                            >
                                <span className="k-icon k-i-save" />
                                &nbsp;{t("Global_Label_Text_Save")}
                            </button>
                        </div>
                    </FormElement>
                )}
            />
        </div>
    );
}